import { SUCCESS, FETCH_SMARTQA } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';
import { SC_SMART_QA, UPDATED } from '../constants/socket';

export default (state = initialState.smartqa, { type, payload }) => {
  switch (type) {
    case FETCH_SMARTQA + SUCCESS:
    case SC_SMART_QA + UPDATED:
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
